import * as types from "../constants";
const initialState: types.LoginAction = {
    isAuth: false,
    isPrimarySalt: true,
    isTokenExpired: false,
    isTokenValid: true,
    CompanyData: {
        CompanyID: "",
        CompanyName: "",
        CompanyTitle: "",
        SignalRHubURL: "",
        allowpayment:"",
    },
    UserData: {
        id: "",
        Token: "",
        RefreshToken: "",
        isAdmin: false,
        isFirstUser: false,
        yoonitGetURL: "",
        yoonitActionURL: "",
        TechAPIURL: "",
        CDNURL: "",
        UserName: "",
        Language: "en",
        TimeZone: 0,
        ZendeskID:''
    },
    ClientData:
    {
        BUID: "",
        ClientID: "",
        ContactID: "",
        ContactStatus: "",
        SalutationID: -1,
        SalutationTxt: "",
        FirstName: "",
        LastName: "",
        Email: "",
        Phone: "",
        CountryID: -1,
        CountryName: "",
        CountryCode: "",
        DOB: "",
        ProfileImage: "",
        IsActive: false,
        RequireKYC: false,
        KYCStatus: "",
        KYCReason: "",
        hasKYC: false,
        NmbrOfAcc: 0,
        CardValidation: false,
        IsValid: false,
        KTID: false,
        AllowAddDemoAcc: false,
        RiskStatementReminder: "",
        PoolID: 0,
        ZipCode: "",
        ResidentialAddress: "",
        City: "",
    },
    AdminData: {
        AUID: "",
        ContactID: "",
        ContactStatus: "",
        SalutationID: -1,
        SalutationTxt: "",
        FirstName: "",
        LastName: "",
        Email: "",
        Phone: "",
        CountryID: -1,
        CountryName: "",
        DOB: "",
        ProfileImage: "",
        IsActive: false
    },
    CompanyAuth: true //so if not set then true
};

export default function reducer(state = initialState, actions: any): types.LoginAction {
    switch (actions.type) {
        case types.AUTH_LOGIN: {
            return {
                ...state,
                isAuth: actions.payload.isAuth,
                isPrimarySalt: actions.payload.isPrimarySalt,
                isTokenExpired: actions.payload.isTokenExpired,
                isTokenValid: actions.payload.isTokenValid,
                UserData: actions.payload.UserData,
                CompanyData: actions.payload.CompanyData,
            };
        }

        case types.REFRESH_TOKENS:
            {
                return {
                    ...state,
                    UserData: {
                        ...state.UserData,
                        Token: actions.payload.token,
                        RefreshToken: actions.payload.refreshToken
                    }
                };
            }
        case types.UPDATE_ZENDESKID:
            {
                return {
                    ...state,
                    UserData: {
                        ...state.UserData,
                        ZendeskID: actions.payload
                    }
                };
            }

        case types.UPDATE_ISVALID:
            {
                return {
                    ...state,
                };
            }
        case types.AUTH_LOGOUT:
            return initialState;
        default:
            return state;
    }
}
